import { Component, input } from '@angular/core';
import { type EnrichedSlot } from './requirements-to-slots';

@Component({
  selector: 'lib-enriched-slot-meta',
  standalone: true,
  // The host attribute makes this element match ng-content select="[slot-meta]"
  // inside DocumentUploadComponent without needing to add the attribute at every call site.
  host: { 'slot-meta': '' },
  template: `
    <div class="flex flex-col gap-3 pb-1">
      @if (item().templateReference) {
        <div class="flex items-center gap-1.5 text-sm">
          <i class="pi pi-file text-gray-400"></i>
          @if (item().templateDownloadUrl) {
            <a
              [href]="item().templateDownloadUrl"
              target="_blank"
              rel="noopener"
              class="text-blue-600 hover:underline"
              >{{ item().templateReference }}</a
            >
          } @else {
            <span class="text-gray-500"
              >{{ item().templateReference }}
              <span class="text-gray-400">(non disponibile)</span></span
            >
          }
        </div>
      }
      @if (item().members.length > 1) {
        <ul class="flex flex-col gap-1.5 text-sm text-gray-600">
          @for (m of item().members; track $index) {
            <li class="flex flex-col gap-0.5">
              <span class="before:mr-1.5 before:text-gray-400 before:content-['•']">{{
                m.name
              }}</span>
              @if (m.description) {
                <span class="ml-4 text-gray-500">{{ m.description }}</span>
              }
              @if (m.condition) {
                <span class="ml-4 text-amber-600"
                  ><i class="pi pi-info-circle mr-0.5 text-xs"></i
                  >{{ m.condition }}</span
                >
              }
            </li>
          }
        </ul>
      } @else {
        @let m = item().members[0];
        @if (m?.description) {
          <p class="text-sm text-gray-500">{{ m.description }}</p>
        }
        @if (m?.condition) {
          <p class="text-sm text-amber-700">
            <i class="pi pi-info-circle mr-1"></i>{{ m.condition }}
          </p>
        }
      }
    </div>
  `,
})
export class EnrichedSlotMetaComponent {
  readonly item = input.required<EnrichedSlot>();
}
